import mutationFactory from '../../lib/mutationFactory';

export default {
  ...mutationFactory({
    singular: 'invoiceValidation',
    plural: 'invoiceValidations'
  }),

  GET_QUEUE_REQUEST: state => {
    state.loadingAction.getQueue = true;
    state.errorAction.getQueue = false;
  },
  GET_QUEUE_SUCCESS: (state, { body }) => {
    state.loadingAction.getQueue = false;
    state.errorAction.getQueue = false;
    state.invoiceValidations = body.data;
    state.total = body.total;
  },
  GET_QUEUE_ERROR: (state, error) => {
    state.loadingAction.getQueue = false;
    state.errorAction.getQueue = error;
  },

  UPLOAD_FILE_REQUEST: state => {
    state.loadingAction.uploadFile = true;
    state.errorAction.uploadFile = false;
  },
  UPLOAD_FILE_PROGRESS: (state, progress) => {
    state.progressAction.uploadFile = progress;
  },
  UPLOAD_FILE_SUCCESS: state => {
    state.loadingAction.uploadFile = false;
    state.errorAction.uploadFile = false;
    state.progressAction.uploadFile = 0;
  },
  UPLOAD_FILE_ERROR: (state, error) => {
    state.loadingAction.uploadFile = false;
    state.errorAction.uploadFile = error;
    state.progressAction.uploadFile = 0;
  },

  DOWNLOAD_FILE_REQUEST: state => {
    state.loadingAction.downloadFile = true;
    state.errorAction.downloadFile = false;
  },
  DOWNLOAD_FILE_SUCCESS: state => {
    state.loadingAction.downloadFile = false;
    state.errorAction.downloadFile = false;
  },
  DOWNLOAD_FILE_ERROR: (state, error) => {
    state.loadingAction.downloadFile = false;
    state.errorAction.downloadFile = error;
  },

  START_CAPTURE_REQUEST: state => {
    state.loadingAction.startCapture = true;
    state.errorAction.startCapture = false;
  },
  START_CAPTURE_SUCCESS: state => {
    state.loadingAction.startCapture = false;
    state.errorAction.startCapture = false;
  },
  START_CAPTURE_ERROR: (state, error) => {
    state.loadingAction.startCapture = false;
    state.errorAction.startCapture = error;
  },

  GET_EXPORT_REQUEST: state => {
    state.loadingAction.getExport = true;
    state.errorAction.getExport = false;
  },
  GET_EXPORT_SUCCESS: state => {
    state.loadingAction.getExport = false;
    state.errorAction.getExport = false;
  },
  GET_EXPORT_ERROR: (state, error) => {
    state.loadingAction.getExport = false;
    state.errorAction.getExport = error;
  },

  REVALIDATE_REQUEST: state => {
    state.loadingAction.revalidate = true;
    state.errorAction.revalidate = false;
  },
  REVALIDATE_SUCCESS: state => {
    state.loadingAction.revalidate = false;
    state.errorAction.revalidate = false;
  },
  REVALIDATE_ERROR: (state, error) => {
    state.loadingAction.revalidate = false;
    state.errorAction.revalidate = error;
  },

  GET_SUMMARY_REQUEST: state => {
    state.loadingAction.getSummary = true;
    state.errorAction.getSummary = false;
  },
  GET_SUMMARY_SUCCESS: state => {
    state.loadingAction.getSummary = false;
    state.errorAction.getSummary = false;
  },
  GET_SUMMARY_ERROR: (state, error) => {
    state.loadingAction.getSummary = false;
    state.errorAction.getSummary = error;
  },

  FORCE_VALIDATE_REQUEST: state => {
    state.loadingAction.forceValidate = true;
    state.errorAction.forceValidate = false;
  },
  FORCE_VALIDATE_SUCCESS: state => {
    state.loadingAction.forceValidate = false;
    state.errorAction.forceValidate = false;
  },
  FORCE_VALIDATE_ERROR: (state, error) => {
    state.loadingAction.forceValidate = false;
    state.errorAction.forceValidate = error;
  },

  LIST_INVOICES_REQUEST: state => {
    state.loadingAction.listInvoices = true;
    state.errorAction.listInvoices = false;
  },
  LIST_INVOICES_SUCCESS: (state, { body }) => {
    state.loadingAction.listInvoices = false;
    state.errorAction.listInvoices = false;
    state.invoices = body.data;
  },
  LIST_INVOICES_ERROR: (state, error) => {
    state.loadingAction.listInvoices = false;
    state.errorAction.listInvoices = error;
  },

  GET_COUNTS_REQUEST: state => {
    state.loadingAction.getCounts = true;
    state.errorAction.getCounts = false;
  },
  GET_COUNTS_SUCCESS: (state, counts) => {
    state.loadingAction.getCounts = false;
    state.errorAction.getCounts = false;
    state.counts = counts;
  },
  GET_COUNTS_ERROR: (state, error) => {
    state.loadingAction.getCounts = false;
    state.errorAction.getCounts = error;
  }
};
